// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import DropzoneController from "./dropzone_controller";
import StorageStatsController from "./storage_stats_controller";

window.Stimulus = Application.start()
Stimulus.register("dropzone", DropzoneController)
Stimulus.register("storage-stats", StorageStatsController)
